import { useState } from 'react';
import { buildPublicArticleUrl } from './articleModalUtils';

const useArticleModalSupportActions = ({
  closeArticle,
  localArticle,
  navigate,
  onSendNewsletter
}) => {
  const [collectionDialogOpen, setCollectionDialogOpen] = useState(false);
  const [shareMenuAnchor, setShareMenuAnchor] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleAddToCollection = () => {
    setCollectionDialogOpen(true);
  };

  const handleCollectionSuccess = ({ collectionsCount }) => {
    console.log(`Artigo adicionado a ${collectionsCount} coleção(ões)`);
  };

  const handleShareMenuOpen = (event) => {
    setShareMenuAnchor(event.currentTarget);
  };

  const handleShareMenuClose = () => {
    setShareMenuAnchor(null);
  };

  const handleCreateNewsletterFromShare = (sharedArticle) => {
    closeArticle();
    if (onSendNewsletter) {
      onSendNewsletter(sharedArticle);
    } else {
      navigate('/newsletter', { state: { selectedArticleIds: [sharedArticle._id] } });
    }
  };

  const handleOpenPublicLink = () => {
    const publicUrl = buildPublicArticleUrl(localArticle?._id);
    if (publicUrl) {
      window.open(publicUrl, '_blank');
    }
  };

  return {
    collectionDialogOpen,
    handleAddToCollection,
    handleCollectionSuccess,
    handleCreateNewsletterFromShare,
    handleOpenPublicLink,
    handleShareMenuClose,
    handleShareMenuOpen,
    setCollectionDialogOpen,
    setSnackbarOpen,
    shareMenuAnchor,
    showSnackbar,
    snackbarMessage,
    snackbarOpen
  };
};

export default useArticleModalSupportActions;
